// we don't do any error checking on props, we assume the caller has done that already
// color (string), width (number of pixels), and height (number of pixels) should always be specified
const Icon = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={props.width}
		height={props.height}
		viewBox="0 0 24 24"
	>
		<path
			fill={props.color}
			d="M3 4H21V2H3V4ZM13 9.8284L19.0711 15.8995L20.4853 14.4853L12 6L3.51472 14.4853L4.92893 15.8995L11 9.8284V21H13V9.8284Z"
		></path>
	</svg>
);

export default Icon;
